export const filterProductsByBedroom = (
  products: any[],
  bedroomCount: number
) => {
  return products?.filter((product: any) => {
    return product?.productDetails?.bedrooms === bedroomCount;
  });
};
